/**
 * SideBarShell — Template-aware SideBar dispatcher.
 *
 * Reads `shellOverrides.SideBarComponent` from TemplateConfigContext.
 * If the active template provides an override, renders it instead of
 * the shared core baseline.
 *
 * This is the explicit shell override contract for SideBar divergence.
 * Templates that need a custom sidebar register shellOverrides.SideBarComponent.
 *
 * Templates that do not override SideBar (cpa, crypto) leave
 * shellOverrides.SideBarComponent undefined — the core baseline is used.
 *
 * Rule: do NOT add skin-name branches here. Use the override slot.
 */
import React from 'react';
import { useTemplateConfig } from '../../context/TemplateConfigContext';
import SideBarDefault from './SideBar.container';

const SideBarShell = (props) => {
    const { shellOverrides } = useTemplateConfig();
    const Override = shellOverrides?.SideBarComponent;

    if (Override) {
        return <Override {...props} />;
    }

    return <SideBarDefault {...props} />;
};

export default SideBarShell;
